// API Configuration
// Update this URL to your AWS EC2 backend URL after deployment

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  SEND_EMAIL: `${API_BASE_URL}/api/send-email`,
  HEALTH_CHECK: `${API_BASE_URL}/api/health`
};

export default API_BASE_URL;
